import { useAuthStore } from "~/stores/auth/store";
import { repository } from "~/repository";
import { ProductTypes } from "~/types";
import { useProcessStore } from "~/stores/process/store";
import { includes } from "lodash-es";

const flowPaths = [
  "/register/select-plan",
  "/register/checkout",
  "/register/verify-email",
  "/register",
  "/account/change-plan",
  "/account/change-plan/checkout",
];

export default defineNuxtRouteMiddleware(async (to, from) => {
  const authStore = useAuthStore();

  const processStore = useProcessStore();

  if (to.query.code && typeof to.query.code === "string") {
    const { data } = await repository.auth.getPromoCodeInformation({
      code: to.query.code,
    });

    const promoCodeInterval = data.Interval;

    if (promoCodeInterval) {
      processStore.promoCodeInfo = data;
      const path =
        authStore.subscription.interval === ProductTypes.NONE
          ? "/register/select-plan"
          : "/account/change-plan";
      return navigateTo(`${path}`);
    }
  } else if (
    includes(flowPaths, from.fullPath) &&
    !includes(flowPaths, to.fullPath)
  ) {
    processStore.promoCodeInfo = undefined;
  }
});
